<template>
  <div>
    <custom-popup
      v-model="addDialog"
      :cons="{ title: 'افزودن جایزه' }"
      hide-confirm
      @close="resetTemp"
    >
      <v-card class="pa-4" flat>
        <luck-edit-fields v-model="tempItem" :errors="errors" />

        <v-card-actions class="justify-end">
          <v-btn
            :loading="loading"
            color="success"
            min-width="110"
            outlined
            @click="saveInfo"
          >
            <v-icon left>mdi-content-save</v-icon>
            ثبت
          </v-btn>
        </v-card-actions>
      </v-card>
    </custom-popup>

    <custom-popup v-model="dialog" :cons="editCons">
      <v-card v-if="computedItem" class="pa-4">
        <v-tabs v-model="selectedIndex">
          <v-tab v-for="(tab, i) in prizes" :key="tab.id">
            {{ tab.name || i + 1 }}
          </v-tab>
        </v-tabs>
        <v-divider />
        <v-tabs-items v-model="selectedIndex">
          <luck-edit-fields v-model="computedItem" :errors="errors" />
        </v-tabs-items>
      </v-card>
    </custom-popup>

    <v-card
      v-for="(item, index) in prizes"
      :key="item.id"
      class="rounded-xl mb-4"
      outlined
      @click="
        () => {
          selectedIndex = index;
          dialog = true;
        }
      "
    >
      <v-card-title>
        {{ item.name || index + 1 }}

        <v-spacer />
        <v-spacer />

        <!-- دکمه‌های کنترل -->
        <div class="d-flex ga-1" @click.stop>
          <!-- <v-btn icon small :disabled="index === 0" @click.stop="moveUp(index)">
            <v-icon small>mdi-arrow-up</v-icon>
          </v-btn>

          <v-btn
            icon
            small
            :disabled="index === prizes.length - 1"
            @click.stop="moveDown(index)"
          >
            <v-icon small>mdi-arrow-down</v-icon>
          </v-btn> -->

          <v-btn
            icon
            small
            color="error"
            @click.stop="deletePrize(item, index)"
          >
            <v-icon small>mdi-delete</v-icon>
          </v-btn>

          <v-btn icon small>
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </div>
      </v-card-title>
    </v-card>

    <v-card-actions>
      <v-btn block color="success" outlined @click="addPrize">
        <v-icon left>mdi-plus</v-icon>
        افزودن جایزه
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import ColorPicker from "@/view/pages/qrland/components/colorPicker.vue";
import PicSelector from "@/view/components/UploadCenter/picSelector.vue";
import LuckEditFields from "@/view/pages/otherQrTypes/luckWheel/cm/luckEditFields.vue";
import { mapGetters } from "vuex";

export default {
  components: { LuckEditFields, PicSelector, ColorPicker },

  props: {
    value: Object,
  },

  data() {
    return {
      editCons: {
        title: "لیست جوایز",
        buttons: [{ type: "submit", handler: this.saveEdit }],
      },
      dialog: false,
      addDialog: false,
      selectedIndex: 0,
      tempItem: {
        name: "",
        color: "",
        icon_path: "",
        quantity: 0,
        chance_percent: 0,
        user_limit: 1,
        recharge_days: null,
        reward_type: "text", // text, link, file, image
        reward_key: "discount",
        reward_value: "",
        excel_data_path: "",
        is_active: true,
      },
      prizes: [],
      errors: {},
      loading: false,
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          this.syncPrizesFromValue();
          // this.getWheelPrizes();
        }
      },
      immediate: true,
      deep: true,
    },
    // "value.prizes": {
    //   handler(newVal) {
    //     if (newVal && Array.isArray(newVal)) {
    //       this.prizes = [...newVal];
    //     }
    //   },
    //   immediate: true,
    //   deep: true,
    // },
  },

  computed: {
    ...mapGetters("localstorage", ["createQrID"]),
    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    computedItem: {
      get() {
        return this.prizes?.length ? this.prizes[this.selectedIndex] : null;
      },
      set(value) {
        this.prizes[this.selectedIndex] = value;
      },
    },
    wheelId() {
      if (this.value && this.value.id) return this.value.id;
      return null;
    },
  },

  methods: {
    openEditDialog(index) {
      this.selectedIndex = index;
      this.dialog = true;
    },

    // جابجایی به بالا
    moveUp(index) {
      if (index === 0) return;
      const temp = this.prizes[index];
      this.prizes[index] = this.prizes[index - 1];
      this.prizes[index - 1] = temp;
      this.updatePrizesOrder();
    },

    // جابجایی به پایین
    moveDown(index) {
      if (index === this.prizes.length - 1) return;
      const temp = this.prizes[index];
      this.prizes[index] = this.prizes[index + 1];
      this.prizes[index + 1] = temp;
      this.updatePrizesOrder();
    },

    updatePrizesOrder() {
      this.$emit("input", {
        ...this.value,
        items: [...this.prizes],
      });
      // this.$emit("input", {
      //   ...this.prizes,
      // });
    },

    // حذف جایزه
    deletePrize(item, index) {
      if (!item.id) {
        this.prizes.splice(index, 1);
        this.updatePrizesOrder();
        return;
      }
      this.$modal
        .yesNo("تایید حذف!", "آیا از حذف این جایزه اطمینان دارید", "neg")
        .then((value) => {
          if (value) {
            this.$api
              .delete(`/v1/testQr/wheels/delete/prize/${this.wheelId}`, {
                data: { prize_id: item.id },
              })
              .then(() => {
                this.$toast.success("جایزه با موفقیت حذف شد.");
                this.prizes.splice(index, 1);
                this.updatePrizesOrder();
                this.$root.$emit("wheel-prizes-updated");
                this.$forceUpdate();
              })
              .catch((err) => {
                this.$toast.error(err.response?.data?.message || "خطا در حذف");
              });
          }
        })
        .catch(() => {});
    },
    getRandomHex() {
      const r = Math.floor(Math.random() * 256)
        .toString(16)
        .padStart(2, "0");
      const g = Math.floor(Math.random() * 256)
        .toString(16)
        .padStart(2, "0");
      const b = Math.floor(Math.random() * 256)
        .toString(16)
        .padStart(2, "0");
      return `#${r}${g}${b}FF`.toUpperCase();
    },
    syncPrizesFromValue() {
      if (this.value && this.value.items && Array.isArray(this.value.items)) {
        this.prizes = [...this.value.items];
      } else if (this.value && Array.isArray(this.value)) {
        this.prizes = [...this.value];
      } else {
        this.prizes = [];
      }
      // if (this.wheelId) {
      //   this.getWheelPrizes();
      // }
    },

    addPrize() {
      this.tempItem = {
        name: "",
        color: this.getRandomHex(),
        icon_path: "",
        quantity: 0,
        chance_percent: 0,
        user_limit: 1,
        recharge_days: null,
        reward_type: "text", // text, link, file, image
        reward_key: "discount",
        reward_value: "",
        excel_data_path: "",
        is_active: true,
      };

      this.addDialog = true;
    },
    resetTemp() {
      this.tempItem = {
        name: "",
        color: "",
        icon_path: "",
        quantity: 0,
        chance_percent: 0,
        // user_limit: 1,
        recharge_days: null,
        reward_type: "text", // text, link, file, image
        reward_key: "",
        reward_value: "",
        excel_data_path: "",
        is_active: true,
      };
    },
    getWheelPrizes() {
      this.$api
        .get("/v1/testQr/wheels", {
          params: {
            qr_id: this.createQrID,
          },
        })
        .then(({ data }) => {
          this.prizes = data.data.prizes;
          this.updatePrizesOrder();
          this.$root.$emit("wheel-prizes-updated");
        })
        .catch(({ response }) => {
          this.$toast.error(response.data?.message || "خطا در دریافت جوایز!");
          this.syncPrizesFromValue();
        });
    },
    saveEdit() {
      this.tempItem = this.computedItem;
      this.saveInfo();
    },
    saveInfo() {
      if (!this.wheelId)
        return this.$toast.error(
          "لطفا ابتدا قسمت اطلاعات را تکمیل و ذخیره نمایید!",
        );

      this.loading = true;

      this.$api
        .post(`/v1/testQr/wheels/${this.wheelId}/prizes`, this.tempItem)
        .then(({ data }) => {
          this.getWheelPrizes();
          this.$toast.success("با موفقیت ذخیره شد.");
          this.addDialog = false;
          this.dialog = false;
          this.$root.$emit("wheel-prizes-updated");
          this.resetTemp();
        })
        .catch(({ response }) => {
          this.errors = response.data?.errors;
          this.$toast.error(response.data?.message || "Invalid data!");
        })
        .finally(() => {
          this.loading = false;
          this.addDialog = false;
          this.dialog = false;
        });
    },
  },
};
</script>

<style scoped>
.v-tabs >>> .v-tabs-slider-wrapper {
  display: block !important;
}
.position-relative {
  position: relative;
}

.ga-1 > * {
  pointer-events: auto;
}
</style>
